module.exports = __webpack_public_path__ + "static/en-section-2@2x-b2daf59ad53e904cf53a5dcfc1ca42af.png";